
import styles from "./TestPage.module.scss";
import { Layout, PageHeader, UnvButton, UnvModal, UnvInput, Icon } from "components";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Notification from "utils/Notifications";
import { PostTest } from "service/TestService";
import TestBody from "./components/TestBody";
import { getTestData, getTestUserData, getTestUserAll } from "service/TestService";
import rewIcon from "assets/icons/pdf.png";
import filerew from 'assets/files/📝_Руководство_пользователя_по_системе_тестирования.pdf'

const TestPage = () => {
  const { t } = useTranslation('common');
  const [activeTab, setActiveTab] = useState('available');
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const [userdata, setDataForUser] = useState([]);
  const [usedata, setData2] = useState([]);

  const getData = async () => {
    try {
      let response = await getTestData(data);
      setData(response.data);

    } catch (error) {
 
    }
  };

  const getDataForUser = async () => {
    try {
      let response = await getTestUserData(data);
      setDataForUser(response.data);
    } catch (error) {
    }
  };
  const getDataForUserAll = async () => {
    try {
      let response_user_data = await getTestUserAll(data);
      setData2(response_user_data.data)
    } catch (error) {
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: t('test.enter_test_name_error'),
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      formData.append('title', body);


      let testsinfo = await PostTest(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: t('test.test_created'),
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {
    getData();
    getDataForUser();
    getDataForUserAll();
    setRender(false)

  }, [render]);
  return (
    <Layout>
      <PageHeader
        icon={<Icon name="test" size={28} />}
        title={t('auto.testpage.title', 'Тестирование')}
        subtitle={t('auto.testpage.subtitle', 'Доступные тесты, конструктор и архив')}
        actions={activeTab === 'create' ? (
          <UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>{t('test.create_test')}</UnvButton>
        ) : null}
      />
      <div className={styles["test-block"]}>
        <div className={styles["tabs"]}>
          <button
            className={`${styles.tab_btn} ${activeTab === 'available' ? styles.active : ''}`}
            onClick={() => setActiveTab('available')}
          >
            <Icon name="book" /> {t('test.available_tests')}
            <span className={styles.h3_3h}>{userdata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'completed' ? styles.active : ''}`}
            onClick={() => setActiveTab('completed')}
          >
            <Icon name="success" /> {t('test.completed_tests')}
            <span className={styles.h3_3h}>{usedata?.length || 0}</span>
          </button>
          <button
            className={`${styles.tab_btn} ${activeTab === 'create' ? styles.active : ''}`}
            onClick={() => setActiveTab('create')}
          >
            <Icon name="tools" /> {t('test.constructor')}
            <span className={styles.h3_3h}>{data?.length || 0}</span>
          </button>
          <a href={filerew} download className={styles.sign__rew__btn}>
            <span><Icon name="note" /> {t('test.guide')}</span>
            <img src={rewIcon} alt={t('test.download_pdf')} />
          </a>
        </div>


        {activeTab === 'create' && (
          <>
          <div className={styles["test-app"]}>
            <h2>{t('test.constructor_title')}</h2>
          </div>
          <TestBody data={data} isadmin={true} />
          </>
        )}

        {activeTab === 'available' && (
          <>
            <div className={styles["test-app"]}>
              <h2><Icon name="book" /> {t('test.available_tests')}</h2>
            </div>
            <TestBody data={userdata} isadmin={false} />
          </>
        )}

        {activeTab === 'completed' && (
          <>
            <div className={styles["test-app"]}>
              <h2><Icon name="success" /> {t('test.completed_title')}</h2>
            </div>
            <TestBody data={usedata} isadmin={false} log={0} />
          </>
        )}

        <UnvModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          title={t('test.create_test_modal')}
          size="sm"
        >
          <form onSubmit={handleSubmit} id="test-create-form">
            <UnvInput
              label={t('test.enter_test_name')}
              placeholder={t('test.enter_test_name')}
              value={body}
              name="body"
              onChange={(e) => setBody(e.target.value)}
              autoFocus
            />
          </form>
          <UnvModal.Footer>
            <UnvButton variant="ghost" onClick={() => setOpenModal(false)}>{t('test.cancel')}</UnvButton>
            <UnvButton variant="primary" iconLeft="plus" type="submit" form="test-create-form">{t('test.create')}</UnvButton>
          </UnvModal.Footer>
        </UnvModal>
        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout>
  );
};

export default TestPage;
